import {useEffect, useState} from 'react'
import ScoreBoard from './components/ScoreBoard'
import purpleStandingRaccoon from'./images/purple-raccoon.png'
import redStandingRaccoon from'./images/red-first-raccoon.png'
import blueStandingRaccoon from'./images/blue-standing-raccoon.jpg'
import brownStandingRaccoon from'./images/borwn-standing-raccoon.jpg'
import greenStandingRaccoon from'./images/green-standing-raccoon.jpg'
import yellowStandingRaccoon from'./images/yellow-standing-raccoon.jpg'
import blank from './images/blank.png'

const width = 8
const candyColors = [
    purpleStandingRaccoon,
    redStandingRaccoon,
    blueStandingRaccoon,
    brownStandingRaccoon,
    greenStandingRaccoon,
    yellowStandingRaccoon
]

const App = () => {
    const [currentColorArrangement, setCurrentColorArrangement] = useState([])
    const [squareBeingDragged, setSquareBeingDragged] = useState(null)
    const [squareBeingReplaced, setSquareBeingReplaced] = useState(null)
    const [scoreDisplay, setScoreDisplay] = useState(0)
    const [userStarts, setUserStarts] = useState(false)

    const checkForColumnOfFour = () => {
        for (let i = 0; i <= 39; i++) {
            const columnOfFour = [i, i + width, i + width * 2, i + width * 3]
            const decidedColor = currentColorArrangement[i]
            const isBlank = currentColorArrangement[i] === blank

            if (columnOfFour.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                console.log("set score")
                if (userStarts) {
                    setScoreDisplay((score) => score + 4)
                }
                columnOfFour.forEach(square => currentColorArrangement[square] = blank)
                return true
            }
        }
    }

    const checkForRowOfFour = () => {
        for (let i = 0; i < 64; i++) {
            const rowOfFour = [i, i + 1, i + 2, i + 3]
            const decidedColor = currentColorArrangement[i]
            const notValid = [5, 6, 7, 13, 14, 15, 21, 22, 23, 29, 30, 31, 37, 38, 39, 45, 46, 47, 53, 54, 55, 62, 63, 64]
            const isBlank = currentColorArrangement[i] === blank

            if (notValid.includes(i)) continue

            if (rowOfFour.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                if (userStarts) {
                    setScoreDisplay((score) => score + 4)
                }
                rowOfFour.forEach(square => currentColorArrangement[square] = blank)
                return true
            }
        }
    }

    const checkForColumnOfThree = () => {
        for (let i = 0; i <= 47; i++) {
            const columnOfThree = [i, i + width, i + width * 2]
            const decidedColor = currentColorArrangement[i]
            const isBlank = currentColorArrangement[i] === blank

            if (columnOfThree.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                if (userStarts) {
                    setScoreDisplay((score) => score + 3)
                }
                columnOfThree.forEach(square => currentColorArrangement[square] = blank)
                return true
            }
        }
    }

    const checkForRowOfThree = () => {
        for (let i = 0; i < 64; i++) {
            const rowOfThree = [i, i + 1, i + 2]
            const decidedColor = currentColorArrangement[i]
            const notValid = [6, 7, 14, 15, 22, 23, 30, 31, 38, 39, 46, 47, 54, 55, 63, 64]
            const isBlank = currentColorArrangement[i] === blank

            if (notValid.includes(i)) continue

            if (rowOfThree.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                if (userStarts) {
                    setScoreDisplay((score) => score + 3)
                }
                rowOfThree.forEach(square => currentColorArrangement[square] = blank)
                return true
            }
        }
    }

    const moveIntoSquareBelow = () => {
        for (let i = 0; i <= 55; i++) {
            const firstRow = [0, 1, 2, 3, 4, 5, 6, 7]
            const isFirstRow = firstRow.includes(i)

            if (isFirstRow && currentColorArrangement[i] === blank) {
                let randomNumber = Math.floor(Math.random() * candyColors.length)
                currentColorArrangement[i] = candyColors[randomNumber]
            }

            if ((currentColorArrangement[i + width]) === blank) {
                currentColorArrangement[i + width] = currentColorArrangement[i]
                currentColorArrangement[i] = blank
            }
        }
    }

    const dragStart = (e) => {
        console.log("drag start")
        setSquareBeingDragged(e.target)
        setUserStarts(true)
    }
    const dragDrop = (e) => {
        setSquareBeingReplaced(e.target)
    }
    const dragEnd = () => {
        console.log("dragEnd")
        const squareBeingDraggedId = parseInt(squareBeingDragged.getAttribute('data-id'))
        const squareBeingReplacedId = parseInt(squareBeingReplaced.getAttribute('data-id'))

        currentColorArrangement[squareBeingReplacedId] = squareBeingDragged.getAttribute('src')
        currentColorArrangement[squareBeingDraggedId] = squareBeingReplaced.getAttribute('src')

        const validMoves = [
            squareBeingDraggedId - 1,
            squareBeingDraggedId - width,
            squareBeingDraggedId + 1,
            squareBeingDraggedId + width
        ]

        const validMove = validMoves.includes(squareBeingReplacedId)

        const isAColumnOfFour = checkForColumnOfFour()
        const isARowOfFour = checkForRowOfFour()
        const isAColumnOfThree = checkForColumnOfThree()
        const isARowOfThree = checkForRowOfThree()

        if (squareBeingReplacedId &&
            validMove &&
            (isARowOfThree || isARowOfFour || isAColumnOfFour || isAColumnOfThree)) {
            setSquareBeingDragged(null)
            setSquareBeingReplaced(null)
        } else {
            currentColorArrangement[squareBeingReplacedId] = squareBeingReplaced.getAttribute('src')
            currentColorArrangement[squareBeingDraggedId] = squareBeingDragged.getAttribute('src')
            setCurrentColorArrangement([...currentColorArrangement])
        }
    }


    const createBoard = () => {
        const randomColorArrangement = []
        for (let i = 0; i < width * width; i++) {
            const randomColor = candyColors[Math.floor(Math.random() * candyColors.length)]
            randomColorArrangement.push(randomColor)
        }
        setCurrentColorArrangement(randomColorArrangement)
    }

    useEffect(() => {
        createBoard()
    }, [])

    useEffect(() => {
        const timer = setInterval(() => {
            console.log("timer")
            checkForColumnOfFour()
            checkForRowOfFour()
            checkForColumnOfThree()
            checkForRowOfThree()
            moveIntoSquareBelow()
            setCurrentColorArrangement([...currentColorArrangement])
        }, 100)
        return () => clearInterval(timer)
    }, [checkForColumnOfFour, checkForRowOfFour, checkForColumnOfThree, checkForRowOfThree, moveIntoSquareBelow, currentColorArrangement])

    // function clickMe() {
    //     console.log("clicked")
    // }


    return (
        <div className="app">
            <div className="game">
                {currentColorArrangement.map((candyColor, index) => (
                    <img
                        key={index}
                        src={candyColor}
                        alt={candyColor}
                        data-id={index}
                        draggable={true}
                        onDragStart={dragStart}
                        onDragOver={(e) => e.preventDefault()}
                        onDragEnter={(e) => e.preventDefault()}
                        onDragLeave={(e) => e.preventDefault()}
                        onDrop={dragDrop}
                        onDragEnd={dragEnd}
                    />
                ))}

            </div>
            Score:
            <ScoreBoard score={scoreDisplay}/>
        </div>
    )
}

export default App























// import { useEffect, useState } from 'react'
// import ScoreBoard from './components/ScoreBoard'
// import purpleStandingRaccoon from'./images/purple-raccoon.png'
// import redStandingRaccoon from'./images/red-first-raccoon.png'
// import blueStandingRaccoon from'./images/blue-standing-raccoon.jpg'
// import brownStandingRaccoon from'./images/borwn-standing-raccoon.jpg'
// import greenStandingRaccoon from'./images/green-standing-raccoon.jpg'
// import yellowStandingRaccoon from'./images/yellow-standing-raccoon.jpg'
// import blank from './images/blank.png'
//
// // import blank from './images/blank.png'
//
// const width = 8
// const raccoonColors = [ // candyColors in video
//     purpleStandingRaccoon,
//     redStandingRaccoon,
//     blueStandingRaccoon,
//     brownStandingRaccoon,
//     greenStandingRaccoon,
//     yellowStandingRaccoon
// ]
//
//
// const App = () => {
//     const [currentColorArrangement, setCurrentColorArrangement] = useState([])
//     const [squareBeingDragged, setSquareBeingDragged] = useState(null)
//     const [squareBeingReplaced, setSquareBeingReplaced] = useState(null)
//
//
//     const checkForColumnOfFour = () => {
//         for (let i = 0; i <= 39; i++){ // 39 to prevent overflowing past grid
//             const columnOfFour = [i, i + width, i + width * 2, i + width * 3] // creating the columns
//             const decidedColor = currentColorArrangement[i] // grabbing the first color to check
//             const isBlank = currentColorArrangement[i] === blank
//
//             if (columnOfFour.every(square => currentColorArrangement[square] === decidedColor)){ // checking if all squares in column match color
//                 columnOfFour.forEach(square => currentColorArrangement[square] = blank) // "clearing" the squares
//                 return true
//             }
//         }
//     }
//
//     const checkForRowOfFour = () => {
//         for (let i = 0; i < 64; i++){
//             const rowOfFour = [i, i + 1, i + 2, i + 3] // creating the rows
//             const decidedColor = currentColorArrangement[i]
//             const notValid = [5, 6, 7, 13, 14, 15, 21, 22, 23, 29, 30, 31, 37, 38, 39, 45, 46, 47, 53, 54, 55, 62, 63, 64] // indexes are invalid to prevent overflowing past grid
//             const isBlank = currentColorArrangement[i] === blank
//
//             if (notValid.includes(i)) continue // checking if row has valid indices
//
//             if (rowOfFour.every(square => currentColorArrangement[square] === decidedColor)){
//                 rowOfFour.forEach(square => currentColorArrangement[square] = blank)
//                 return true
//             }
//         }
//     }
//
//     const checkForColumnOfThree = () => {
//         for (let i = 0; i <= 47; i++){
//             const columnOfThree = [i, i + width, i + width * 2]
//             const decidedColor = currentColorArrangement[i]
//             const isBlank = currentColorArrangement[i] === blank
//
//             if (columnOfThree.every(square => currentColorArrangement[square] === decidedColor)){
//                 columnOfThree.forEach(square => currentColorArrangement[square] = blank)
//                 return true
//             }
//         }
//     }
//
//     const checkForRowOfThree = () => {
//         for (let i = 0; i < 64; i++){
//             const rowOfThree = [i, i + 1, i + 2]
//             const decidedColor = currentColorArrangement[i]
//             const notValid = [6, 7, 14, 15, 22, 23, 30, 31, 38, 39, 46, 47, 54, 55, 63, 64]
//             const isBlank = currentColorArrangement[i] === blank
//
//             if (notValid.includes(i)) continue
//
//             if (rowOfThree.every(square => currentColorArrangement[square] === decidedColor)){
//                 rowOfThree.forEach(square => currentColorArrangement[square] = blank)
//                 return true
//             }
//         }
//     }
//
//     const moveToSquareBelow = () => {
//         for(let i = 0; i <= 55; i++){
//             const firstRow = [0, 1, 2, 3, 4, 5, 6, 7]
//             const isFirstRow = firstRow.includes(i)
//
//             if (isFirstRow && currentColorArrangement[i] === blank){
//                 let randomNum = Math.floor(Math.random() + raccoonColors.length)
//                 currentColorArrangement[i] = raccoonColors[randomNum]
//
//             }
//
//
//             if ((currentColorArrangement[i] + width) === blank){
//                 currentColorArrangement[i + width] = currentColorArrangement[i]
//                 currentColorArrangement[i] = blank
//             }
//         }
//     }
//
//     const dragStart = (e) => {
//         setSquareBeingDragged(e.target)
//         // stores location of raccoon being dragged
//     }
//
//     const dragDrop = (e) =>{
//         setSquareBeingReplaced(e.target)
//         //stores location of raccoon being dragged onto
//     }
//
//     const dragEnd = (e) =>{
//         // recalls locations of squares being dragged
//         const squareBeingDraggedId = parseInt(squareBeingDragged.getAttribute('data-id'))
//         const squareBeingReplacedId = parseInt(squareBeingReplaced.getAttribute('data-id'))
//
//         // swaps colors of squares
//         currentColorArrangement[squareBeingReplacedId] = squareBeingDragged.getAttribute('src')
//         currentColorArrangement[squareBeingDraggedId] = squareBeingReplaced.getAttribute('src')
//
//         console.log(squareBeingDraggedId)
//         console.log(squareBeingReplacedId)
//
//         // computes an array of valid moves based on the square being dragged
//         const validMoves = [
//             squareBeingDraggedId -1,
//             squareBeingDraggedId - width,
//             squareBeingDraggedId + 1,
//             squareBeingDraggedId + width
//
//         ]
//
//         const validMove = validMoves.includes(squareBeingReplacedId) // checks if current move is within the array of all possible valid moves
//
//         const isAColumnOfFour = checkForColumnOfFour()
//         const isARowOfFour = checkForRowOfFour()
//         const isAColumnOfThree = checkForColumnOfThree()
//         const isARowOfThree = checkForRowOfThree()
//         // checks if current move will result in a valid match
//
//         // resets board after move
//         if (squareBeingReplacedId && validMove &&
//             (isARowOfThree || isARowOfFour || isAColumnOfFour || isAColumnOfThree)){
//             setSquareBeingDragged(null)
//             setSquareBeingReplaced(null)
//             }
//             else { // resets board to previous state if move is invalid
//             currentColorArrangement[squareBeingReplacedId] = squareBeingReplaced.getAttribute('src')
//             currentColorArrangement[squareBeingDraggedId] = squareBeingDragged.getAttribute('src')
//             setCurrentColorArrangement([...currentColorArrangement])
//             }
//     }
//
//     const createBoard = () => {
//         const randomColorArrangement = []
//         for (let i = 0; i < width * width; i++) {
//             // Get a random color but getting random index
//             // Floor will round down so that index doesn't go out of bounds
//             // const randomNumberFrom0to5 = Math.floor(Math.random() * raccoonColors.length)
//             // console.log(randomNumberFrom0to5)
//             const randomColor = raccoonColors[Math.floor(Math.random() * raccoonColors.length)]
//             randomColorArrangement.push(randomColor);
//         }
//         setCurrentColorArrangement(randomColorArrangement) // currentColorArrangment = randomColorArrangement
//     }
//
//     // Performs side effect
//     // Tells react to something after render
//     // only calls createBoard() once
//     useEffect(() => {
//         createBoard()
//     }, []) // empty array because only want to be called once
//
//     useEffect(() => {
//         // checking board every 100 milliseconds
//         const timer = setInterval(() => {
//             checkForColumnOfFour()
//             checkForRowOfFour()
//             checkForColumnOfThree()
//             checkForRowOfThree()
//             moveToSquareBelow()
//             setCurrentColorArrangement([...currentColorArrangement]) // taking an array and expanding it into individual elements
//         }, 100)
//         return () => clearInterval(timer)
//
//     }, [checkForColumnOfFour, checkForRowOfFour, checkForColumnOfThree, checkForRowOfThree, moveToSquareBelow, currentColorArrangement]) // dependencies
//
//     return (
//         <div className="app">
//             <div className="game">
//                 {currentColorArrangement.map((raccoonColors, index) =>
//                     <img
//                         key={index}
//                         src={raccoonColors}
//                         alt={raccoonColors}
//                         data-id={index} // return index of current raccoon
//                         draggable={true}
//                         onDragStart={dragStart}
//                         onDragOver={(e) => e.preventDefault()}
//                         onDragEnter={(e) => e.preventDefault()}
//                         // checks for when user begins to drag raccoon images
//                         onDragLeave={(e) => e.preventDefault()}
//                         onDrop={dragDrop}
//                         onDragEnd={dragEnd}
//                         // checks for when user drops raccoon images
//                         // calls seperate drag functions that store image location data
//                     />
//                 )}
//             </div>
//
//         </div>
//     )
//
// }
//
// export default App;
